var srcImagen = function srcImagen(nombre) {
  return 'contenido/' + nombre + '.png';
};

export var getContenidoTipoPng = function getContenidoTipoPng(state, zona) {
  var vinculo = zona.vinculo;

  var _vinculo$split = vinculo.split(','),
      nombreFichero = _vinculo$split[1];

  var contenido = {
    tipo: 'png',
    imagen: srcImagen(nombreFichero)
  };
  return contenido;
};